import { render, staticRenderFns } from "./Assemble.vue?vue&type=template&id=0deb6b49&scoped=true"
import script from "./Assemble.vue?vue&type=script&lang=js"
export * from "./Assemble.vue?vue&type=script&lang=js"
import style0 from "./Assemble.vue?vue&type=style&index=0&id=0deb6b49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deb6b49",
  null
  
)

export default component.exports